import React from "react";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";

export default function Grid({ settings, blocks }) {
  const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);

  return (
    <div className={`flex ${isMobile ? "flex-col" : "flex-row"} gap-8`}>
      <div className={`flex flex-col gap-6 lg:gap-11 ${isMobile ? "text-center items-center" : "max-w-[386px]"}`}>
        <h2 className={isMobile ? settings.section.title_font_style_mobile : settings.section.title_font_style}>{settings.section.title}</h2>
        <p className={isMobile ? settings.section.content_font_style_mobile : settings.section.content_font_style}>{settings.section.content}</p>
      </div>
      <div className={isMobile ? "overflow-x-auto no-scrollbar pl-3" : "w-full"}>
        <div className={`grid ${isMobile ? "gap-5  grid-flow-col grid-rows-1" : "gap-8 grid-cols-2"} auto-cols-[minmax(280px,1fr)]`}>
          {blocks.map((block, index) => (
            <div key={index} className="gradient-border flex flex-col gap-[35px] min-w-[280px] lg:min-w-auto px-8 py-12">
              {(block.settings.image_icon || block.settings.title) && (
                <div className="space-y-3">
                  {block.settings.image_icon && (
                    <img
                      src={block.settings.image_icon}
                      alt={block.settings.title}
                    />
                  )}
                  {block.settings.title && (
                    <h3 className={isMobile ? block.settings.title_font_style_mobile : block.settings.title_font_style}>
                      {block.settings.title}
                    </h3>
                  )}
                </div>
              )}
              {block.settings.content &&
                <p className={isMobile ? block.settings.content_font_style_mobile : block.settings.content_font_style}
                  dangerouslySetInnerHTML={{ __html: block.settings.content }}
                ></p>
              }
              {block.settings.button_text &&
                <a href={block.settings.button_url} className="link link-primary cursor-pointer py-3 pr-6">
                  <span className="button__label">{block.settings.button_text}</span>
                  <span className="icon-right-arrow-alt button__icon no-underline"></span>
                </a>
              }
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}